export const MESSENGER_API_VERSION = 'v17.0';
export const AUTHENTICATED_PAYLOAD_COMMENT = `  // You can set true/false here if you want to authenticate your request`;
export const ASYNC_PAYLOAD_COMMENT = `  // You can set true/false here if you want to user typing experience enable.`;

export const INTEGRATIONS_CONTAINER_NAME = 'integrations';
